import { render, staticRenderFns } from "./McpPt.vue?vue&type=template&id=5d6ad880&scoped=true"
import script from "./McpPt.vue?vue&type=script&lang=js"
export * from "./McpPt.vue?vue&type=script&lang=js"
import style0 from "./McpPt.vue?vue&type=style&index=0&id=5d6ad880&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6ad880",
  null
  
)

export default component.exports